import React from 'react';

import { FormAutoCompleteCombo, FormSelect } from '../../../../components';

import { arrayOf, func, object, string } from 'prop-types';

import {
  CATEGORY_APIS_LIST_STATUS_FILTER_OPTIONS,
  CATEGORY_APIS_LIST_APPLICABLE_FILTER_OPTIONS,
  CATEGORY_APIS_LIST_COMPLIANCE_FILTER_OPTIONS,
  CATEGORY_APIS_LIST_ASSIGNED_FILTER_OPTIONS,
} from '../../../../constants';

export const FilterByState = (props) => (
    <FormSelect
      {...props}
      id="tc-apis-filter-by-state"
      data-apim-test="tc-apis-filter-by-state"
      data={CATEGORY_APIS_LIST_STATUS_FILTER_OPTIONS}
      noNoneOption
      noNativeSelect
    />
);

export const FilterByOrganization = (props) => {
  
  const onChange = (e, value) =>
    props.handleChange(e, value);

  return (
      <FormAutoCompleteCombo
        {...props}
        id="user-filter-by-organization"
        onChange={onChange}
      />
  );
};

FilterByOrganization.propTypes = {
  handleChange: func,
  data: arrayOf(object),
  value: string,
};


export const FilterByApplicable = (props) => (
  <FormSelect
    {...props}
    id="tc-apis-filter-by-applicability"
    data-apim-test="tc-apis-filter-by-applicability"
    data={CATEGORY_APIS_LIST_APPLICABLE_FILTER_OPTIONS}
    noNoneOption
    noNativeSelect
  />
);


export const FilterByCompliance = (props) => (
  <FormSelect
    {...props}
    id="tc-apis-filter-by-compliance"
    data-apim-test="tc-apis-filter-by-compliance"
    data={CATEGORY_APIS_LIST_COMPLIANCE_FILTER_OPTIONS}
    noNoneOption
    noNativeSelect
  />
);


export const FilterByAssigned = (props) => (
  <FormSelect
    {...props}
    id="tc-apis-filter-by-assigned"
    data-apim-test="tc-apis-filter-by-assigned"
    data={CATEGORY_APIS_LIST_ASSIGNED_FILTER_OPTIONS}
    noNoneOption
    noNativeSelect
  />
);